<template>
  <div>Dashboard {{ project_id }}</div>
</template>
<script>
export default { props: ['project_id'] };
</script>
